/**
 * @generated SignedSource<<e1177a1d3670ae73598e531cc663b738>>
 * @relayHash 4454a52ea4ab532f76ee4e80586f3a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87

import type { ConcreteRequest } from 'relay-runtime';
export type CatchupContentType = "BLOGPOST" | "PAGE" | "%future added value";
export type useDynamicSplitButtonCatchupLastViewedTimeQuery$variables = {
  contentId: string;
  contentType: CatchupContentType;
};
export type useDynamicSplitButtonCatchupLastViewedTimeQuery$data = {
  readonly catchupGetLastViewedTime: {
    readonly lastViewedTimeISO: string | null;
  } | null;
};
export type useDynamicSplitButtonCatchupLastViewedTimeQuery = {
  response: useDynamicSplitButtonCatchupLastViewedTimeQuery$data;
  variables: useDynamicSplitButtonCatchupLastViewedTimeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentType"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentType",
        "variableName": "contentType"
      }
    ],
    "concreteType": "CatchupLastViewedTimeResponse",
    "kind": "LinkedField",
    "name": "catchupGetLastViewedTime",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "lastViewedTimeISO"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4454a52ea4ab532f76ee4e80586f3a56",
    "id": "1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87",
    "metadata": {},
    "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
    "operationKind": "query",
    "text": "query useDynamicSplitButtonCatchupLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
  }
};
})();

(node as any).hash = "ca230a2a5e683b85178d392f9c872c98";

export default node;
